var fowtr_module_modals = (function (fowtr_module_modals) {

      
      // console.log('fowtr_module_modals initialised');




      // fowtr_module_utilities.disableScroll();

      $("#fowtr-wrapper").on('click', '.fowtr-coming-soon', function(e) {
        e.preventDefault();
        var modal = $(this).attr('data-fowtr-modal');
        modal = $('#'+modal);
        $('.fowtr-modal-overlay').fadeIn();
        modal.fadeIn();
        fowtr_module_utilities.disableScroll();
      });





      // $("#fowtr-wrapper").on('click', '.fowtr-coming-soon', function(e) {
      //   e.preventDefault();
      //   var modal = $(this).attr('data-fowtr-modal');
      //   modal = $('#'+modal);
      //   $('.fowtr-modal-overlay').fadeIn();
      //   modal.fadeIn();
      //   fowtr_module_utilities.disableScroll();
      // });

       // $("#fowtr-wrapper #fowtr-chapter4 #fowtr-article11").one('inview', function(event, visible) {
       //     // event.stopPropagation();
       //     // if(!$(event.target).is(this)) return;
       //     console.log('potato');
       //     if (visible) {
       //        // var id = $(this).next().attr('id');
       //        // var id = $(this).attr('data-section');
       //        // if(id){
       //        //   id = id.replace('fowtr-article','');
       //        //   fowtr_module_analytics.currentSectionInView = id;
       //        //   console.log('currentSectionInView',fowtr_module_analytics.currentSectionInView);
       //        //   // tracking_adobe('Viewed chapter 2 section','Section','View',id);
       //        //   // tracking_decibel('Viewed chapter 2 section','Section','View',id);
       //        // }
       //     } else {
       //      // hidden
       //     }
       // });




      // =================================================
      // MODAL POPUPS
      // =================================================
      var openModal;

      $("[data-fowtr-modal-video]").on('click', function(e) {
      // $("#fowtr-wrapper").on('click','[data-fowtr-modal-video]', function(e) {
        e.preventDefault();
        var modal = $('#fowtr-modal-video');
        var src = $(this).attr('data-fowtr-modal-video');
        // modal = $('#'+modal);
        //set the 'opened' modal
        openModal = modal;
        $('#fowtr-modal-video .fowtr-video-container iframe').attr('src', src);


        //clear the set width and height
        openModal.width("");
        openModal.height("");

        if(modal.hasClass('fowtr-modal-full')){
          resizeOpenModal();
        }

        $('.fowtr-modal-overlay').fadeIn();
        modal.fadeIn();
      });




      $("[data-fowtr-modal]").on('click', function(e) {
        e.preventDefault();
        var modal = $(this).attr('data-fowtr-modal');
        modal = $('#'+modal);
        $('.fowtr-modal-overlay').fadeIn();
        modal.fadeIn();
        //set the 'opened' modal
        openModal = modal;

        //clear the set width and height
        openModal.width("");
        openModal.height("");

        if(modal.hasClass('fowtr-modal-full')){
          resizeOpenModal();
        }
      });

      // image modal
      $("#fowtr-wrapper").on('click','[data-fowtr-image-modal]', function(e) {
        e.preventDefault();
        var modal = $(this).attr('data-fowtr-image-modal');
        modal = $('#'+modal);
        console.log(modal);

        var src = $(this).attr('href');
        $('#fowtr-wrapper > #fowtr-image-modal .fowtr-modal-content').html('');
        $('<img/>')
            .on('load', function() {
              $('#fowtr-wrapper > .fowtr-image-modal-overlay').fadeIn();
              $('#fowtr-wrapper > #fowtr-image-modal').fadeIn('slow');
              //set the 'opened' modal
              openModal = modal;
              // //clear the set width and height
              openModal.width("");
              openModal.height("");
              // make it fit
              resizeOpenModal();
            })
            // .on('error', function() { console.log("error loading image"); })
            .attr("src", src)
            .appendTo($('#fowtr-wrapper > #fowtr-image-modal .fowtr-modal-content'))
        ;
      });

      var original_video_location = false;
      // movingimage video modal
      $("#fowtr-wrapper").on('click','[data-fowtr-mi24-modal]', function(e) {
        e.preventDefault();
        var modal = $(this).attr('data-fowtr-mi24-modal');
        if($(this).closest('.fowtr-modal-content').length) {
          closeModal();
          return false;
        }

        modal = $('#'+modal);
        console.log(modal);

        var src = $(this).attr('href');
        $('#fowtr-wrapper > #fowtr-image-modal .fowtr-modal-content').html('');


        original_video_location = $(this).closest('.fowtr-mi24-video-wrapper');
        var container = $(this).closest('.fowtr-mi24-video');
        container.appendTo($('#fowtr-wrapper > #fowtr-image-modal .fowtr-modal-content'))
        // modal.data('original_video_location',wrapper);
        $('#fowtr-wrapper > .fowtr-image-modal-overlay').fadeIn();
        $('#fowtr-wrapper > #fowtr-image-modal').fadeIn('slow');
        //set the 'opened' modal
        openModal = modal;
        // //clear the set width and height
        openModal.width("1105");
        openModal.height("621");
        // make it fit
        resizeOpenModal();






        // $('<img/>')
        //     .on('load', function() {
        //       $('#fowtr-wrapper > .fowtr-image-modal-overlay').fadeIn();
        //       $('#fowtr-wrapper > #fowtr-image-modal').fadeIn('slow');
        //       //set the 'opened' modal
        //       openModal = modal;
        //       // //clear the set width and height
        //       openModal.width("");
        //       openModal.height("");
        //       // make it fit
        //       resizeOpenModal();
        //     })
        //     // .on('error', function() { console.log("error loading image"); })
        //     .attr("src", src)
        //     .appendTo($('#fowtr-wrapper > #fowtr-image-modal .fowtr-modal-content'))
        // ;
      });


      // this runs if there is ANY modal open
      function resizeOpenModal() {
        // return;
        // console.log('resizing modal');
        var padding = 20;
        var marginTop = 0;
        var sw = $(window).width() - (padding*2);
        var sh = $(window).height() - (padding*2) - marginTop;
        var mw = openModal.width();
        var mh = openModal.height();
        var scale = Math.min( 
          sw / mw, 
          sh / mh 
        );
        openModal.width(Math.floor(mw*scale));
        openModal.height(Math.floor(mh*scale));
      }


      // resize on browser resize
      $(window).on('resize', function(){
        if(openModal) resizeOpenModal();
      });


      // CLOSE
      $(".fowtr-modal-close, .fowtr-modal-overlay, #fowtr-image-modal img").on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('close');
        closeModal();
        // fowtr_module_utilities.enableScroll();
        // $('.fowtr-modal-overlay').stop(true, true).fadeOut('fast');
        // $('.fowtr-modal, .fowtr-coming-soon-modal').stop(true, true).fadeOut('fast',function(){
        //   //stop any videos in popups
        //   $('.fowtr-modal .fowtr-video-container iframe').each(function(){
        //     // this.src = this.src;
        //     this.src = "";
        //     // this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        //   });
        // });
        // console.log(original_video_location);
        // if(original_video_location){
        //   openModal.find('.fowtr-modal-content > div').appendTo(original_video_location);
        // }
        // original_video_location = false;
        // openModal = false;

      });

      function closeModal(){
        fowtr_module_utilities.enableScroll();
        $('.fowtr-modal-overlay').stop(true, true).fadeOut('fast');
        $('.fowtr-modal, .fowtr-coming-soon-modal, .fowtr-popup').stop(true, true).fadeOut('fast',function(){
          //stop any videos in popups
          $('.fowtr-modal .fowtr-video-container iframe').each(function(){
            // this.src = this.src;
            this.src = "";
            // this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
          });
        });
        console.log(original_video_location);
        if(original_video_location){
          openModal.find('.fowtr-modal-content > div').appendTo(original_video_location);
        }
        original_video_location = false;
        openModal = false;
      }


    fowtr_module_modals.openPopup = function(id){
      var modal = $('#'+id);
      // openModal = modal;
      $('.fowtr-modal-overlay.fowtr-popup-overlay').fadeIn();
      modal.fadeIn();
    };


    fowtr_module_modals.init = function(){
      
    };

    return fowtr_module_modals;
}(fowtr_module_modals || {}));